export const PHONE = "5531987696304";
export const PHONE_LABEL = "(31) 98769-6304";
export const ADDRESS = "Praça Enfermeira Geralda Marra, 100 - São João Batista, Belo Horizonte - MG";

export const waLink = (msg = "Olá! Quero agendar minha sessão no Laser Day da Aisla Studio.") =>
  `https://wa.me/${PHONE}?text=${encodeURIComponent(msg)}`;

export const scrollState = { lenis: null };

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (scrollState.lenis) scrollState.lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];
